import { BigNumber, Contract } from "ethers";
import {
  decodeResultMulticallZkSync,
  formatMulticallResults,
} from "utils/contract/decodeResultMulticall";

/**
 * Get each token provider in list token array.
 * @param {Array} listToken - Array of token (each token must have a property `address`)
 * @param {Contract} PriceContractInfo - Info of price contract (must have a property `address` and `abi`)
 * @param {Multicall} provider
 * @return {(Object)} Return the object with `[key]:value` where key is a token address and value is an address of price provider
 */
export default async function handleGetListTokenProvider(
  listToken = [],
  PriceContractInfo,
  provider,
  multicallContract
) {
  const listRequestToGetPythProvider = [];

  const PriceContract = new Contract(PriceContractInfo.address, PriceContractInfo.abi, provider);

  listToken.forEach((token) => {
    listRequestToGetPythProvider.push({
      target: PriceContract.address,
      callData: PriceContract.interface.encodeFunctionData("tokenPriceProvider", [token.address]),
      reference: token.symbol,
      methodName: "tokenPriceProvider",
      methodParameters: [token.address],
      value: BigNumber.from(0),
      contract: PriceContract,
      contractName: "PriceContractTokenProvider",
    });
  });

  const valueOfRequest = listRequestToGetPythProvider.map((r) =>
    "value" in r ? r.value : BigNumber.from(0)
  );
  const totalValue = valueOfRequest.reduce((pre, cur) => pre.add(cur), BigNumber.from(0));

  const resultMulticall = await multicallContract.callStatic.aggregate3Value(
    listRequestToGetPythProvider,
    {
      value: totalValue,
    }
  );

  const returnData = formatMulticallResults(resultMulticall);
  const results = decodeResultMulticallZkSync(listRequestToGetPythProvider, returnData);

  const priceProviderList = results.PriceContractTokenProvider.reduce((prev, curr) => {
    const key = curr.methodParameters[0];
    const priceProvider = curr.returnValues[0];

    return { ...prev, [key]: priceProvider };
  }, {});

  return priceProviderList;
}
